import type { DispatchPreview } from '../dispatch.api';

export interface DispatchBlocker {
  key: 'status' | 'crew' | 'readiness' | 'eligibility';
  message: string;
}

/** Everything that would make the server refuse a dispatch now, in the order a dispatcher fixes them. Empty means the button is live. */
export function dispatchBlockers(preview: DispatchPreview): DispatchBlocker[] {
  if (preview.trip.status !== 'assigned') return [{ key: 'status', message: `This trip is ${preview.trip.status}, so it cannot be dispatched.` }];
  const blockers: DispatchBlocker[] = [];
  const { truck, driver } = preview.crew;
  if (!truck || !driver) blockers.push({ key: 'crew', message: 'The trip needs a truck and a driver.' });
  const outstanding = preview.readiness.items.filter((item) => !item.met && !item.overridden);
  if (!preview.readiness.ready || outstanding.length > 0) {
    const names = outstanding.map((item) => item.label).join(', ');
    blockers.push({ key: 'readiness', message: names ? `The job is not ready: ${names}.` : 'The job is not ready.' });
  }
  if (!preview.eligibility.isEligible) blockers.push({ key: 'eligibility', message: 'The crew is not eligible; resolve or override the blocks below.' });
  return blockers;
}
